import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import type { ServiceItem } from "../data/solutions";

type ServiceDetailPageProps = {
    item: ServiceItem;
    category: "solutions" | "software";
    categoryLabel: string;
};

const renderImage = (item: ServiceItem, isMobile: boolean) => {
    const useSvg = isMobile || item.desktopImageType === "svg";

    if (useSvg) {
        return (
            <ReactSVG
                className="card-image"
                src={item.image}
                beforeInjection={(svg) => {
                    svg.setAttribute("width", "100%");
                    svg.setAttribute("height", "auto");
                    svg.removeAttribute("style");
                }}
            />
        );
    }

    return <img alt={item.title} className="card-image" src={item.image} loading="lazy" />;
};

export const ServiceDetailPage = ({ item, category, categoryLabel }: ServiceDetailPageProps) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 800);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const imageOnLeft = item.imagePosition === "left";
    const imageElement = renderImage(item, isMobile);
    const textElement = (
        <div className="card-text">
            <div className="heading" style={{ color: item.headingColor }}>
                {item.title}
            </div>
            {isMobile && imageElement}
            <div className="title">{item.tagline}</div>
            <div className="sub-title">{item.description}</div>
        </div>
    );

    return (
        <>
            <div className="detail-breadcrumb">
                <Link to="/">Home</Link>
                <span> / </span>
                <span>{categoryLabel}</span>
                <span> / </span>
                <span>{item.title}</span>
            </div>
            <div className="heading detail-page-heading">
                {category === "solutions" ? (
                    <>
                        Business Growth-Enabling <span style={{ color: "#9e00ff" }}>Solutions</span>
                    </>
                ) : (
                    <>
                        Business Growth-Accelerating <span style={{ color: "#9e00ff" }}> Software</span>
                    </>
                )}
            </div>
            <div className="cards-section detail-cards-section">
                <div className="card detail-card">
                    {!isMobile && imageOnLeft && imageElement}
                    {textElement}
                    {!isMobile && !imageOnLeft && imageElement}
                </div>
            </div>
        </>
    );
};
